



























































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import DsEditor from "@/components/ds-editor/ds-editor.vue";

@Component({
  components: {
    DsEditor,
  },
})
export default class ReportConfigDialog extends Vue {
  @Prop()
  private ifShow: boolean | undefined;
  @Prop()
  private configData: any;

  private get visible() {
    return this.ifShow || false;
  }

  private set visible(val: boolean) {
    this.$emit("update:ifShow", val);
  }

  private config: any = {
    show_comment: true, // 是否显示注释内容，默认是
    cover_type: "default", // 封面类型：default 默认，custom 自定义
    cover_content: "", // 自定义封面内容
  };

  private editorKey: number = 0; // 用于强制重新渲染编辑器
  private editorReady: boolean = false; // 控制编辑器是否准备好显示

  @Watch("ifShow", { immediate: true })
  private onVisibleChange(newVal: boolean) {
    if (newVal) {
      // 弹框打开时，使用从父组件传入的配置数据
      this.updateConfigFromData();
      // 延迟显示编辑器，确保数据已经准备好
      this.editorReady = false;
      this.$nextTick(() => {
        // 如果选择了自定义封面，延迟显示编辑器
        if (this.config.cover_type === 'custom') {
          setTimeout(() => {
            this.editorKey = Date.now();
            this.editorReady = true;
          }, 100);
        }
      });
    } else {
      // 弹框关闭时重置
      this.editorReady = false;
    }
  }

  // 监听 configData 变化，确保数据更新时同步更新配置
  @Watch("configData", { deep: true, immediate: true })
  private onConfigDataChange() {
    if (this.ifShow) {
      this.updateConfigFromData();
      // 数据更新后，如果选择了自定义封面，重新创建编辑器
      if (this.config.cover_type === 'custom') {
        this.editorReady = false;
        this.$nextTick(() => {
          setTimeout(() => {
            this.editorKey = Date.now();
            this.editorReady = true;
          }, 100);
        });
      }
    }
  }

  /**
   * @description 从 configData 更新配置
   */
  private updateConfigFromData() {
    if (this.configData) {
      console.log('更新配置，configData:', this.configData);
      this.config = {
        show_comment: this.configData.show_comment ?? true,
        cover_type: this.configData.cover_type || "default",
        cover_content: this.configData.cover_content || "",
      };
      console.log('更新后的 config:', this.config);
      console.log('cover_content 值:', this.config.cover_content);
    } else {
      // 如果没有配置数据，使用默认值
      this.config = {
        show_comment: true,
        cover_type: "default",
        cover_content: "",
      };
    }
  }

  @Watch("config.cover_type")
  private onCoverTypeChange(newVal: string) {
    if (newVal === "default") {
      this.config.cover_content = "";
      this.editorReady = false;
    } else if (newVal === "custom") {
      // 切换到自定义时，显示编辑器
      this.editorReady = false;
      this.$nextTick(() => {
        setTimeout(() => {
          this.editorKey = Date.now();
          this.editorReady = true;
        }, 100);
      });
    }
  }

  /**
   * @description 编辑器内容变化
   */
  private onEditorChange(content: string) {
    this.config.cover_content = content;
  }

  /**
   * @description 关闭弹框
   */
  private close() {
    this.visible = false;
    this.$emit("close");
  }

  /**
   * @description 取消
   */
  private cancel() {
    this.close();
  }

  /**
   * @description 保存配置
   */
  private save() {
    // 保存配置到 localStorage 或发送到 API
    localStorage.setItem("reportConfig", JSON.stringify(this.config));
    this.$emit("save", { ...this.config });
    this.close();
  }
}
